<template>
    <div class="region-component" :class="{ '-selected': isSelected}">

        <button type="button" class="selected-component" @click="onSelect">
            <i class="fal fa-circle"></i>
            <i class="fal fa-check-circle"></i>
        </button>

        <div class="name"  @click="onSelect">{{region.label}}</div>


    </div>
</template>


<style  src="./RegionComponentStyles.css"></style>

<script lang="ts">

    import { defineComponent, ref, reactive, computed, inject, PropType, Ref } from 'vue';
    import LocationEntryTSVM from '@Types/search/LocationEntryTSVM';
    import { FilterSelectionLocation, FilterSelectionLocationEntry } from '@Types/FilterSelections';




    export default defineComponent({


        props: {

            region: {
                type: Object as PropType<LocationEntryTSVM>,
                required: true
            },
        },
        emit: ['select'],

        setup(props, context) {


            const filterSelectionLocation = inject("filterSelectionLocation") as Ref<FilterSelectionLocation>;


            const isSelected = computed(() => {

                if (filterSelectionLocation.value.hasValue()) {

                    // should not have city, but region only
                    if (!filterSelectionLocation.value.selection[0].cityValueId) {

                        return filterSelectionLocation.value.selection[0].regionValueId === props.region.id;
                    }

                }

                return false;
            });

            const onSelect = () => {

                context.emit('select', props.region);
            };


            return {

                isSelected,
                onSelect,

                region: props.region,

            };
        }



    });


</script>